import { thousands } from './tools';
import {
  STOCK_PLACE_MAP,
  getStockPlaceCurrency,
  isStockPlace,
} from 'constant/stock-place';
import { CURRENCY_MAP } from 'constant/currency';

/** 商品售价税率：按库存地优先，JPY 商品默认 10% 消费税 */
export const getProductTaxRate = (stockPlace?: string, currency?: string) => {
  if (stockPlace === STOCK_PLACE_MAP.DUBAI) return 0.05;
  if (stockPlace === STOCK_PLACE_MAP.SINGAPORE_ASU_GST) return 0.09;
  if (stockPlace === STOCK_PLACE_MAP.FRANCE) return 0.2;
  if (stockPlace === STOCK_PLACE_MAP.NEW_YORK) return 0.08875;
  if (currency === CURRENCY_MAP.JPY) return 0.1;
  return 0;
};

export const formatCurrencyByStockPlace = (
  value: number,
  stockPlace?: string,
) => {
  const currency =
    stockPlace && isStockPlace(stockPlace)
      ? getStockPlaceCurrency(stockPlace)
      : CURRENCY_MAP.JPY;

  return `${currency} ${thousands(value)}`;
};
